import { Deserializable } from '../../protocols/deserializable';
import { Address } from '../dto/address';
import { CreateAttachmentRequest } from './create-attachment-request';

export class MpSelfEnrolmentRequest implements Deserializable {
  firstName!: string;
  middleName: string | null = null;
  lastName!: string;
  preferredName: string | null = null;
  email!: string;
  password!: string;
  socialInsuranceNumber!: string;
  birthDate!: string;
  genderId!: number;
  pronounId!: number;
  allowThirdPartyContributions!: boolean;
  primaryPhoneNumberCountryCode!: string;
  primaryPhoneNumber!: string;
  secondaryPhoneNumberCountryCode: string | null = null;
  secondaryPhoneNumber: string | null = null;
  address!: Address;
  attachments!: CreateAttachmentRequest[];

  onDeserialize() {}
}
